export default __webpack_public_path__ + "static/media/img-ourteam-header.71e0d0b2.jpg";